// Vendor Libs
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

// Dish Tech React
import {useForm, useOverlay, useService} from '@dishtech-react/hooks';
import {CrudDataTable, Overlay} from '@dishtech-react/core';

// Components
import LoadingSpinner from '../layout/loading-spinner';
import RoleForm from './role-form';

// Config
import {serviceConfig} from '../../../config/service-config';
import {tableConfig} from '../../../config/table-config';

const SERVICE_KEY = 'ROLE';

const Role = () => {
    const {serviceContent, registerService, unregisterService} = useService(SERVICE_KEY);
    const {registerForm, setFieldValues} = useForm(serviceConfig, SERVICE_KEY, 'update');
    const {content: roles = []} = serviceContent;
    const {columns} = tableConfig[SERVICE_KEY];
    const fetching = useSelector(state => (state.service && state.service.ROLE ? state.service.ROLE.fetching : true));

    const {
        closeOverlay: closeCreateOverlay,
        open: isCreateOverlayOpen,
        openOverlay: openCreateOverlay,
        overlayId: createOverlayId,
    } = useOverlay({
        title: 'create_role',
    });
    const {
        closeOverlay: closeUpdateOverlay,
        open: isUpdateOverlayOpen,
        openOverlay: openUpdateOverlay,
        overlayId: updateOverlayId,
    } = useOverlay({
        title: 'update_role',
    });

    useEffect(() => {
        registerService();

        return () => unregisterService();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleUpdateButtonClick = roleId => {
        const promise = registerForm();
        const formValues = roles.find(role => role.roleId === roleId);

        promise.then(() =>
            setFieldValues({
                ...formValues,
                clientId: formValues.client.clientId,
                childRoleIds: formValues.childRoles.map(({roleId: childRoleId}) => childRoleId),
            }).then(() => {
                openUpdateOverlay();
            })
        );

        return promise;
    };

    return fetching ? (
        <LoadingSpinner />
    ) : (
        <>
            <CrudDataTable
                canCreate={true}
                canUpdate={true}
                columnConfig={columns}
                data={roles.map(({childRoles, client: {clientId} = {}, name, ...rest}) => ({
                    childRoles: childRoles.map(({name: childName}) => `${childName}`.toLowerCase()).sort(),
                    client: clientId,
                    name,
                    ...rest,
                }))}
                idKey="roleId"
                itemLabel="Role"
                options={{
                    selectableRows: 'none',
                }}
                title="Role Management"
                onCreate={openCreateOverlay}
                onUpdate={handleUpdateButtonClick}
            />
            <Overlay id={createOverlayId} open={isCreateOverlayOpen} title="Create Role">
                <RoleForm onCancel={closeCreateOverlay} onSave={closeCreateOverlay} />
            </Overlay>
            <Overlay id={updateOverlayId} open={isUpdateOverlayOpen} title="Update Role">
                <RoleForm mode="update" onCancel={closeUpdateOverlay} onSave={closeUpdateOverlay} />
            </Overlay>
        </>
    );
};

export default Role;
